"use client";

import React, { useEffect, useRef, useState } from 'react';

const Symbol = ({ loadingMessage = 'Loading...', maxWidth }) => {
    const symbolRef = useRef(null);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // Update our state when observer callback fires
                setIsActive(entry.isIntersecting);
            },
            {
                root: null, // relative to document viewport
                rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
                threshold: 0.1, // visible amount of item shown in relation to root
            },
        );

        if (symbolRef.current) {
            observer.observe(symbolRef.current);
        }

        return () => {
            if (symbolRef.current) {
                observer.unobserve(symbolRef.current);
            }
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return (
        <div className="sons-symbol-wrapper">
            <div
                ref={symbolRef}
                className={`sons-symbol site-footer__logo ${isActive ? 'is-active' : ''}`}
                style={{ maxWidth: maxWidth }}
            >
                <div className="sons-symbol__container">
                    <div className="sons-symbol__part top-left"></div>
                    <div className="sons-symbol__part top-right"></div>
                    <div className="sons-symbol__part bottom-left"></div>
                    <div className="sons-symbol__part bottom-right"></div>
                </div>
            </div>
        </div>
    );
};

export default Symbol;
